import { absoluteUrl, buildRouteSchema, findRouteMetadata, type RouteMetadata } from '../data/routeRegistry';

function upsertMeta(selector: string, attrs: Record<string, string>, content: string): void {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement('meta');
    for (const [key, value] of Object.entries(attrs)) element.setAttribute(key, value);
    document.head.appendChild(element);
  }
  element.content = content;
}

function upsertCanonical(href: string): void {
  let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  link.href = href;
}

function upsertJsonLd(route: RouteMetadata): void {
  const existing = document.head.querySelector<HTMLScriptElement>('script[data-route-schema="true"]');
  if (existing) existing.remove();

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.dataset.routeSchema = 'true';
  const schema = buildRouteSchema(route);
  script.textContent = JSON.stringify(schema.length === 1 ? schema[0] : schema);
  document.head.appendChild(script);
}

export function applyRouteMetadata(pathname: string): RouteMetadata | null {
  const route = findRouteMetadata(pathname);
  if (!route) return null;

  const canonical = absoluteUrl(route.path);
  document.title = route.title;
  upsertMeta('meta[name="description"]', { name: 'description' }, route.description);
  upsertMeta('meta[property="og:title"]', { property: 'og:title' }, route.title);
  upsertMeta('meta[property="og:description"]', { property: 'og:description' }, route.description);
  upsertMeta('meta[property="og:url"]', { property: 'og:url' }, canonical);
  upsertMeta('meta[property="og:type"]', { property: 'og:type' }, route.kind === 'product' ? 'product' : 'website');
  upsertMeta('meta[name="twitter:card"]', { name: 'twitter:card' }, 'summary_large_image');
  upsertCanonical(canonical);
  upsertJsonLd(route);
  return route;
}
